import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from '@/contexts/AuthContext'
import { TooltipProvider } from '@/components/ui/tooltip'
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { Toaster } from "@/components/ui/toaster"
import Login from '@/pages/Login'
import ResetPassword from '@/pages/ResetPassword'
import Index from '@/pages/Index'
import NotFound from '@/pages/NotFound'
import PublicHome from '@/pages/PublicHome'
import Register from '@/pages/Register'
import AcceptInvite from '@/pages/AcceptInvite'
import SentryTest from '@/pages/SentryTest'

const queryClient = new QueryClient()

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { firebaseUser, emailVerified, loading } = useAuth()

  if (loading) return <div>Loading...</div>

  if (!firebaseUser) return <Navigate to="/login" replace />
  if (!emailVerified) return <Navigate to="/login?verify=1" replace />

  return <>{children}</>
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <AuthProvider>
          <Router>
            <Routes>
              <Route path="/" element={<PublicHome />} />
              <Route path="/home" element={<PublicHome />} />
              <Route path="/register" element={<Register />} />
              <Route path="/login" element={<Login />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/accept-invite/:token" element={<AcceptInvite />} />
              <Route path="/_sentry-test" element={<SentryTest />} />
              <Route
                path="/app"
                element={
                  <ProtectedRoute>
                    <Index />
                  </ProtectedRoute>
                }
              />
              {/* Legacy: /admin was the workspace URL before we introduced
                  the ADMIN role. Redirect so bookmarks and any in-flight
                  invite-flow URLs keep working. */}
              <Route path="/admin" element={<Navigate to="/app" replace />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Router>
        </AuthProvider>
      </TooltipProvider>
    </QueryClientProvider>
  )
}

export default App
